module.exports = __webpack_public_path__ + "img/4.8d986a85.jpg";